import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../../main/main.styles';

export const VppaModalStyles = css`
  ${MainStyles}
  .dialog-content {
    height: calc(100% - 145px);
    overflow: auto;
  }

  .dialog-form-content {
    height: calc(100% - 145px);
    overflow: auto;
    padding: 16px;
  }

  right-side-modal fast-dialog .right-dialog {
    --dialog-width: 357px;
  }

  .dialog-content zero-tabs.top-level::part(tablist) {
    background: transparent;
  }

  .dialog-content .top-level zero-tab {
    width: 50%;
    margin: 0;
    background: transparent;
    border: none;
    box-shadow: none;
    font-size: 13px;
    color: var(--top-level-tab-font);
  }

  .dialog-content .top-level zero-tab[aria-selected='true'] {
    color: var(--primary-color);
    border-bottom: 1px solid var(--primary-color);
  }

  .dialog-content .top-level zero-tab[aria-selected='false']:hover {
    color: #fff;
  }

  .dialog-content zero-tab-panel {
    margin: 16px;
  }

  .errors-title {
    color: rgb(255 182 96 / 99%);
    text-align: left;
    font-size: 15px;
    padding: 24px 16px 0;
    margin: 0;
    line-height: 12px;
  }

  .success-title {
    color: var(--completed);
    text-align: left;
    font-size: 15px;
    padding: 24px 16px 0;
    margin: 0;
    line-height: 12px;
  }

  .confirm-text {
    color: var(--nest-level-tab-font);
    text-align: left;
    font-size: 13px;
    padding: 12px 16px 0;
    margin: 0;
    line-height: 12px;
  }

  .button-length {
    width: 233px;
  }

  .cancel-button {
    margin-right: 23px;
  }
`;
